import React from "react";
import { Col, Input } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";

interface Props {
  title: string;
  id: string;
  showSpinner: boolean;
  showInfo: boolean;
  infoId: string;
  isDisabled: boolean;
  checked: boolean;
  className: any;
  colClassName: any;
  colSize: any;
  onChangeHandler: (event) => void;
}

class ChoiceInput extends React.PureComponent<Props> {
  static defaultProps = {
    id: "choiceInputId",
    isDisabled: false,
    checked: false,
    className: s.titleLabel,
    colClassName: s.choice,
    colSize: 12,
    showInfo: false,
    infoId: "choiceInputId",
  };

  render() {
    const {
      title,
      onChangeHandler,
      id,
      isDisabled,
      checked,
      className,
      showInfo,
      infoId,
    } = this.props;

    return (
      <Col className={this.props.colClassName} sm={this.props.colSize}>
        <div className={s.checkboxRow}>
          <Input
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChangeHandler}
            disabled={isDisabled}
          />
          <label htmlFor={id} />
          <span className={!isDisabled ? className : s.isDisabled}>
            {title}

            {showInfo && (
              <span data-tip={`tooltip-${infoId}`} data-for={`tp${infoId}`}>
                <i className="fa fa-question-circle" />
              </span>
            )}
          </span>
        </div>
      </Col>
    );
  }
}

export default withStyles(s)(ChoiceInput);
